module.exports = __webpack_public_path__ + "static/inkblot-greenShield-logo-colour-fr-c83f0a3dd19a3ea4e6d0fbfea97dda3c.png";